import React, { useState } from 'react';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import CustomSelect from '../../../common/formElements/CustomSelect';
import CustomInputWithIcon from '../../../common/ui/CustomInputWithIcon';
import { getLanguagesForSelect } from '../../../common/utils/languages';

export const ActiveLanguagesForm = ({
  projectId,
  localization,
  saveLocalizationConfig,
  maximumActiveLanguages,
}) => {
  const [activeLanguage, setActiveLanguage] = useState('');
  const isDefault = localization && localization.length === 0;
  const placeholderText = isDefault
    ? 'Select Default Language'
    : `Select Language ${localization.length}`;
  return (
    <form className="form-horizontal">
      <div className="row mx-auto">
        <div className="col-md-9 col-lg-9 col-sm-9 col-xs-9">
          <CustomInputWithIcon title="Active Language" icon="select" required={true}>
            <CustomSelect
              name="language"
              isMulti={false}
              options={getLanguagesForSelect()}
              value={activeLanguage}
              onChange={(name, value) => setActiveLanguage(value)}
              placeholder={placeholderText}
            />
          </CustomInputWithIcon>
        </div>
        <div className="col-md-3 col-lg-3 text-right">
          <button
            className="btn btn-theme-submit btn-md"
            disabled={!(localization.length < maximumActiveLanguages)}
            onClick={(e) => {
              e.preventDefault();
              saveLocalizationConfig({ projectId, language: activeLanguage, isDefault });
            }}
          >
            <i className={`wb ${drapcodeIcon('add')}`}></i>&nbsp;Add Language&nbsp;
          </button>
        </div>
      </div>
    </form>
  );
};
